export default __webpack_public_path__ + "static/media/P308.1.1aebb383.mp3";